// import Repository from './Repository'
import axios from 'axios'
import { countryConfig } from '../country-config/country-config'

const baseURL = countryConfig.isColombia ? 'https://stunning-base-164402.appspot.com/_ah/api/' : 'https://oracle-services-vzla.uc.r.appspot.com/_ah/api/';
const endpoint = 'categoryEndpoint'

const token = countryConfig.isColombia ? '8c7c8876451374b1978bcbd8167e427e' : '2ebbd70db2be0b9b51e4ae178a05347c'
const tokenIdWebSafe = countryConfig.isColombia ?
    'ahZzfnN0dW5uaW5nLWJhc2UtMTY0NDAycl4LEgVDVXNlciIkZTc2MGUxYmMtMDBlMi00ZGU2LWEwZGYtNDk5OGNiOGEzNDBjDAsSBVRva2VuIiRmODlhNjUwMi05MmJjLTRiYWEtODlhNi1hMGU2MjEwYjY0ZWEM' :
    'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcl0LEgRVc2VyIiQyOGJlMjcwMC1hYmViLTQyZjEtOTYwNy05MGMxNDUyZDg4NzAMCxIFVG9rZW4iJDI5Y2NhNjdhLWI0ZjgtNGZiMi04NWM2LTlhNDAxMWQ4OTNmNQw'

const Repository = axios.create({ baseURL })

export default {
    get() {
        return Repository.get(`${endpoint}/getCategoriesAndSubCategories`, { params: { token, tokenIdWebSafe } })
    },
}
